import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import { createVitalsByAppointmentIdWoLoader } from "../../../redux/reducers/clinicSlice";
import { updateWeightByPetAndApntId } from "../../../redux/reducers/petSlice";

const UpdatePetWeight = ({ modVsble, details = {}, onCloseMod = () => {} }) => {
  const dispatch = useDispatch();
  const [petValues, setPetValues] = useState({ weight: "", weightErr: "" });

  useEffect(() => {
    if (details?.weight?.length > 0) {
      setPetValues({ ...petValues, weight: details?.weight });
    }
  }, [details]);

  const onChange = (name, value) => {
    const reqObj = {
      ...petValues,
      [name]: value,
      weightErr: value?.length > 0 ? "" : "This field is required",
    };
    setPetValues(reqObj);
  };

  const onUpdateWeight = () => {
    if (petValues?.weight?.length === 0 || !petValues?.weight) {
      return setPetValues({
        ...petValues,
        weightErr: "This field is required",
      });
    }
    dispatch(
      updateWeightByPetAndApntId({
        url: `/${details?.appointmentId}/pet/${details?.petId}/weight?weight=${petValues?.weight}`,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseMod("apiSuccess");
        const data = {
          vitalGroupId: 1,
          vitalGroup: "Core Vitals",
          data: [{ "Body Weight": petValues?.weight }],
        };
        dispatch(
          createVitalsByAppointmentIdWoLoader({
            apntId: details?.appointmentId,
            data,
          }),
        );
      }
    });
  };

  return (
    <CustomModal
      open={modVsble}
      onClose={() => onCloseMod("close")}
      header="Update Weight"
      modal
      modalWidth={30}
      headerBold
    >
      <div className="ph20">
        <CustomTextField
          name="weight"
          value={petValues?.weight}
          fullWidth
          handleChange={(e) => onChange("weight", e?.target?.value)}
          label="Weight"
          error={!!petValues.weightErr}
          helperText={petValues.weightErr}
          type="number"
          suffix={petValues?.weight !== "" ? "Kg" : ""}
        />
        <div className="flex1-end mv20">
          <div>
            <CustomButton text="Update" smallBtn onClick={onUpdateWeight} />
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default UpdatePetWeight;
